import { FieldModel } from '../extraction-models';
import { DataAwareValidator } from '../../domain-extraction-specifications';
import { Validations } from '@ps-gui/ui';
import { FieldType } from '@ps-gui/shared-utils';

const INLINE_CONSOLIDATION_POSTFIX = '_consolidation';

export const Daten301erExtractionModel = {
  '301er_daten_geschlecht': {
    key: '301er_daten_geschlecht',
    label: { text: 'Geschlecht', genus: 'N' },
    type: FieldType.STRING,
    index: 0,
  },
  '301er_daten_geschlecht_consolidation': {
    key: '301er_daten_geschlecht' + INLINE_CONSOLIDATION_POSTFIX,
    label: { text: 'Geschlecht (KODIP)', genus: 'N' },
    type: FieldType.DROPDOWN,
    inlineConsolidatorForField: '301er_daten_geschlecht',
    options: ['U', 'M', 'W', 'D'].map((x) => ({
      label: x,
      value: x,
    })),
    index: 0,
  },
  '301er_daten_vorname_geschaedigter': {
    key: '301er_daten_vorname_geschaedigter',
    label: { text: 'Vorname', genus: 'M' },
    type: FieldType.STRING,
    index: 0,
  },
  '301er_daten_nachname_geschaedigter': {
    key: '301er_daten_nachname_geschaedigter',
    label: { text: 'Nachname', genus: 'M' },
    type: FieldType.STRING,
    index: 0,
  },
  '301er_daten_geburtsdatum_geschaedigter': {
    key: '301er_daten_geburtsdatum_geschaedigter',
    label: { text: 'Geburtsdatum', genus: 'N' },
    type: FieldType.DATE,
    index: 0,
  },
  '301er_daten_aufnahmedatum': {
    key: '301er_daten_aufnahmedatum',
    label: { text: 'Aufnahmedatum', genus: 'N' },
    type: FieldType.DATE,
    index: 1,
    validators: [Validations.date()],
  },
  '301er_daten_aufnahmeuhrzeit': {
    key: '301er_daten_aufnahmeuhrzeit',
    label: { text: 'Aufnahmeuhrzeit', genus: 'F' },
    type: FieldType.TIME,
    index: 2,
    validators: [Validations.time()],
  },
  '301er_daten_entlassungsdatum': {
    key: '301er_daten_entlassungsdatum',
    label: { text: 'Entlassungsdatum', genus: 'N' },
    type: FieldType.DATE,
    index: 3,
    validators: [Validations.date()],
  },
  '301er_daten_entlassungsuhrzeit': {
    key: '301er_daten_entlassungsuhrzeit',
    label: { text: 'Entlassungsuhrzeit', genus: 'F' },
    type: FieldType.TIME,
    index: 4,
    validators: [Validations.time()],
  },
  '301er_daten_ik_nummer': {
    key: '301er_daten_ik_nummer',
    label: { text: 'IK-Nummer', genus: 'F' },
    type: FieldType.STRING,
    index: 5,
  },
  '301er_daten_beatmungsstunden': {
    key: '301er_daten_beatmungsstunden',
    label: { text: 'Beatmungsstunden', genus: 'F' },
    type: FieldType.NUMBER,
    index: 13,
    customTransformValue: (value) => value.split(',')[0],
    validators: [Validations.naturalNumber()],
  },
  '301er_daten_tage_ohne_brechung': {
    key: '301er_daten_tage_ohne_brechung',
    label: { text: 'Tage ohne Berechnung (ToB)', genus: 'F' },
    type: FieldType.NUMBER,
    index: 14,
    validators: [Validations.naturalNumber()],
  },
  '301er_daten_entgeltbereich': {
    key: '301er_daten_entgeltbereich',
    label: { text: 'Entgeltbereich', genus: 'M' },
    type: FieldType.STRING,
    index: 15,
  },
  '301er_daten_entgeltbereich_consolidation': {
    key: '301er_daten_entgeltbereich' + INLINE_CONSOLIDATION_POSTFIX,
    label: { text: 'Entgeltbereich (KODIP)', genus: 'M' },
    type: FieldType.DROPDOWN,
    inlineConsolidatorForField: '301er_daten_entgeltbereich',
    options: ['AMB', 'AMB §115b', 'DRG', 'HYB', 'BWD', 'BWH', 'BGD', 'BGH', 'PEPP', 'PIA'],
    index: 16,
  },
  '301er_daten_drg': {
    key: '301er_daten_drg',
    label: { text: 'DRG', genus: 'M' },
    type: FieldType.STRING,
    index: 17,
    customTransformValue: (value) => (value && value.length > 4 ? value.slice(-4) : value),
  },
  '301er_daten_aufnahmegrund': {
    key: '301er_daten_aufnahmegrund',
    label: { text: 'Aufnahmegrund (KODIP)', genus: 'M' },
    type: FieldType.DROPDOWN,
    options: [
      {
        label: '01 - Krankenhausbehandlung, vollstationär',
        value: '01',
      },
      {
        label: '02 - Krankenhausbehandlung, vollstationär mit vorstationärer Behandlung',
        value: '02',
      },
      {
        label: '03 - Krankenhausbehandlung, teilstationär',
        value: '03',
      },
      {
        label: '04 - Vorstat. Behandlung ohne anschl. vollstat. Behandlung.',
        value: '04',
      },
      {
        label: '05 - Stationäre Entbindung',
        value: '05',
      },
      {
        label: '06 - Geburt',
        value: '06',
      },
      {
        label: '07 - Wiederaufnahme wegen Komplikation',
        value: '07',
      },
      {
        label: '08 - Stat. Aufnahme zur Organentnahme',
        value: '08',
      },
      {
        label: '10 - Stationsäquivalente Behandlung (StäB)',
        value: '10',
      },
      {
        label: '11 - Übergangspflege',
        value: '11',
      },
      {
        label: '12 - Krankenhausbehandlung nach § 115f SGB V',
        value: '12',
      },
      {
        label: '13 - Hybrid-DRG durch Vertragsarzt',
        value: '13',
      },
    ],
    index: 18,
    validators: [],
  },
  '301er_daten_entlassungsgrund': {
    key: '301er_daten_entlassungsgrund',
    label: { text: 'Entlassungsgrund (KODIP)', genus: 'M' },
    type: FieldType.DROPDOWN,
    options: [
      {
        label: '01 - Behandlung regulär beendet',
        value: '01',
      },
      {
        label: '02 - Behandlung regular beendet, nachstationäre Behandlung vorgesehen',
        value: '02',
      },
      {
        label: '03 - Behandlung aus sonstigen Gründen beendet',
        value: '03',
      },
      {
        label: '04 - Behandlung gegen ärztlichen Rat beendet',
        value: '04',
      },
      {
        label: '05 - Zuständigkeitswechsel des Kostenträgers',
        value: '05',
      },
      {
        label: '06 - Verlegung in ein anderes Krankenhaus',
        value: '06',
      },
      {
        label: '07 - Tod',
        value: '07',
      },
      {
        label:
          '08 - Verlegung in ein anderes Krankenhaus im Rahmen einer Zusammenarbeit (§ 14 Abs. 5 Satz 2 BPflV)',
        value: '08',
      },
      {
        label: '09 - Entlassung in eine Rehabilitationseinrichtung',
        value: '09',
      },
      {
        label: '10 - Entlassung in eine Pflegeeinrichtung',
        value: '10',
      },
      {
        label: '11 - Entlassung in ein Hospiz',
        value: '11',
      },
      {
        label: '12 - Interne Verlegung',
        value: '12',
      },
      {
        label: '13 - Externe Verlegung zur psychiatrischen Behandlung',
        value: '13',
      },
      {
        label:
          '14 - Behandlung aus sonstigen Gründen beendet, nachstationäre Behandlung vorgesehen',
        value: '14',
      },
      {
        label: '15 - Behandlung gegen ärztlichen Rat beendet, nachstationäre Behandlung vorgesehen',
        value: '15',
      },
      {
        label:
          '16 - Externe Verlegung mit Rückverlegung oder Wechsel zwischen den Entgeltbereichen der DRG-Fallpauschalen',
        value: '16',
      },
      {
        label:
          '17 - Interne Verlegung mit Wechsel zwischen den Entgeltbereichen der DRG-Fallpauschalen',
        value: '17',
      },
      {
        label: '18 - Rückverlegung',
        value: '18',
      },
      {
        label: '19 - Entlassung von Wiederaufnahme mit Neueinstufung',
        value: '19',
      },
      {
        label: '20 - Entlassung vor Wiederaufnahme mit Neueinstufung wegen Komplikationen',
        value: '20',
      },
      {
        label: '21 - Entlassung mit nachfolgender Wiederaufnahme',
        value: '21',
      },
      {
        label:
          '22 - Fallabschluss (interne Verlegung) bei Wechsel zwischen voll-, teilstationärer und stationsäquivalenter Behandlung',
        value: '22',
      },
      {
        label: '23 - Beginn eines externen Aufenthalts mit Abwesenheit über Mitternacht',
        value: '23',
      },
      {
        label: '24 - Beendigung eines externen Aufenthalts mit Abwesenheit über Mitternacht',
        value: '24',
      },
      {
        label: '25 - Entlassung zum Jahresende bei Aufnahme im Vorjahr (§ 4 PEPPV 2013)',
        value: '25',
      },
      {
        label:
          '26 - Beginn eines Zeitraumes ohne direkten Patientenkontakt (stationsäquivalente Behandlung)',
        value: '26',
      },
      {
        label:
          '27 - Beendigung eines Zeitraumes ohne direkten Patientenkontakt (stationsäquivalente Behandlung - für Pseudofachabteilung 0004)',
        value: '27',
      },
      {
        label: '28 - Behandlung regulär beendet, beatmet entlassen (ungültig ab 2022)',
        value: '28',
      },
      {
        label: '29 - Behandlung regulär beendet, beatmet verlegt (ungültig ab 2022)',
        value: '29',
      },
      {
        label: '30 - Überleitung in die Übergangspflege',
        value: '30',
      },
      {
        label: '31 - Beginn eines externen Aufenthalts (tagesstat. Behandlung)',
        value: '31',
      },
      {
        label:
          '32 - Reguläre Beendigung eines externen Aufenthalts bei tagesstationärer Behandlung',
        value: '32',
      },
      {
        label:
          '33 - Ungeplante Beendigung eines externen Aufenth. bei tagesstat. Behandlung - Notfall',
        value: '33',
      },
      {
        label:
          '34 - Ungeplante Beendigung eines externen Aufenth. bei tagesstat. Behandlung - medizinischer Behandlungsbedarf',
        value: '34',
      },
      {
        label:
          '35 - Ungeplante Beendigung eines externen Aufenth. bei tagesstat. Behandlung - Wunsch des Patienten',
        value: '35',
      },
    ],
    index: 19,
    validators: [],
  },
} satisfies Record<
  string,
  FieldModel & {
    dataAwareValidator?: DataAwareValidator;
  }
>;
